import React from 'react';
import * as Icons from 'components/icons';
import { formatDate, MONTHDAY_MONTHNAME_YEAR } from 'utils/time-and-date';
import { Text } from 'components/typography';
import { Button } from 'components/form-elements';
import { forms } from 'global/theming/variants/forms';

const labeledStyles = forms.input.labeled;

const displayDate = selectedDate => formatDate(selectedDate, MONTHDAY_MONTHNAME_YEAR);

export const LabeledDateTrigger = ({ selectedDate: { selectedDateFrom, selectedDateTo }, onChange }) => (
  <Button
    sx={{
      display: 'flex',
      alignItems: 'center',
      ...labeledStyles,
    }}
  >
    {selectedDateFrom || selectedDateTo ? (
      <>
        <Text fontSize={14}>
          {selectedDateFrom && displayDate(selectedDateFrom)} - {selectedDateTo && displayDate(selectedDateTo)}
        </Text>

        <Icons.Discard
          as="div"
          sx={{ marginLeft: 'auto' }}
          onClick={(e) => {
            e.stopPropagation();
            onChange({ selectedDateFrom: null, selectedDateTo: null });
          }}
        />
      </>
    ) : <Icons.Calendar sx={{ marginLeft: 'auto' }} />}
  </Button>
);
